import { useMutation } from 'react-query';
import { journalVehicleApi } from '../../api';

const useDelete = () => {
  const mutation = useMutation((id: number): any => {
    return journalVehicleApi.delete(id);
  });
  return mutation;
};

export default useDelete;
